<template>
  <div id="app">
    <div class="ck-navtop wf-nav">
      <div class="block1200 block1620 clearfix">
        <div class="div-img">
          <a href="/" class="nav-logo">
            <span class="logo1"><img src="./assets/images/logo.png?v106" alt=""></span>
            <i class="vr"></i>
            <img class="sublogo" src="./assets/images/logo-sub.png?v106" alt="文献相似性检测服务">
          </a>
        </div>
        <ul class="nav">
          <li :class="['/submit', '/submit/:product', '/payform/:tradeId'].indexOf($route.path) > -1 && 'active'"><router-link to="/submit">提交查重</router-link></li>
          <li :class="['/reports', '/reports/:transactionId'].indexOf($route.path) > -1 && 'active'"><router-link to="/reports">查看结果</router-link></li>
          <li><a href="http://truth.wanfangdata.com.cn/" target="a_blank">报告验真</a></li>
        </ul>
      </div>
    </div>
    <div class="wfc-content">
      <div class="mainCon">
        <router-view></router-view>
      </div>
    </div>
    <div class="ck-footer">
      <div class="block1200 block1620">    
        <div class="copy-right">
          <div style="padding-top: 15px;">
            <a id="_xinchacharenzheng_cert_vip_kexinweb" style="text-decoration:none;" target="_blank" href="https://xyt.xinchacha.com/pcinfo?sn=458869876094799872&certType=6">
              <img src="https://xyt.xinchacha.com/img/icon/icon3.png" height="35" />
            </a>
            <a target="cyxyv" href="https://v.yunaq.com/certificate?domain=www.wanfangtech.com&from=label&code=90020" style="margin: 0 10px;">
              <img src="https://aqyzmedia.yunaq.com/labels/label_sm_90020.png" height="35" />
            </a>
            <a id="_pingansec_bottomimagelarge_brand" target="_blank" href="//si.trustutn.org/info?sn=405200615039766732120&certType=1">
              <img src="//v.trustutn.org/images/cert/brand_realname_large_img.png" height="35" />
            </a>
          </div>  
          <div style="line-height: 2em; padding: 0 150px 25px">
            关于我们:我司致力于提供多样化的科技信息服务。以客户为导向，依托强大的数据采集能力，应用先进的信息处理技术和检索技术，为科技界、企业界和政府部门提供高质量的信息资源产品。并陆续推出万方查重、万方毕业论文管理系统、万方VR虚拟教育平台等一系列产品。<br />
          ©2020-2020 万方科技版权所有，并保留所有权利。 <span style="display:block;width: 30"></span>粤ICP备20046369号
          </div>
        </div>
      </div>
    </div>
    <div class="wf-side-bar">
    <ul>
        <li class="side-kf">
            <a :href="$store.state.check.userProduct.qrCodeUrlPath" target="_blank">
                <div class="img-box"></div>
                <span style="font-size: 12px">联系我们</span>
            </a>

        </li>
        <li class="side-wx">
            <div class="img-box"></div>
            <span>微信</span>
            <div class="side-layout">
                <div class="blue-head"></div>
                <div class="side-box">
                    <img :src="$store.state.check.qrUrl" style="width: 140px">
                    <p>关注公众号，了解更多内容<span style="color: #cb3944"></span></p>
                </div>
            </div>
        </li>
        <li class="side-qq" >
            <div class="img-box"></div>
            <span>QQ在线</span>
            <div class="side-layout">
                <!-- <div class="blue-head"></div> -->
                <div class="side-box">
                    <div style="border-bottom: 1px solid #93badd;padding: 3px;font-weight: bold;">咨询客服</div>
                    <div style=" padding: 3px 10px;text-align:left">
                      <p><a-icon type="qq" theme="outlined" :style="qqIcon"/>在线客服</p>
                      <p style="padding-left: 12px;"><span style="display: inline-block;width: 46px;">QQ客服</span>：{{ $store.state.check.userProduct.serviceQq }}</p>
                      <p style="padding-left: 12px;"><span style="display: inline-block;width: 46px;">工作日</span>：9:00 - 18:00</p>
                    </div>
                </div>
            </div>
        </li>
        <li class="side-gt goto-top" @click="toTop">
            <div class="img-box"></div>
            <span>顶部</span>
        </li>
    </ul>
  </div>
  </div>
</template>

<script>
import { Icon } from 'ant-design-vue'
export default {
  name: 'App',
  components: {
    AIcon:Icon
  },
  data() {
    return {
      // isHover:false,
      qqIcon:{
        // fontSize:'16px',
        marginRight:'2px'

      }
    }
  },
  created () {
    this.$store.dispatch('check/getUserProduct', {
      payload: {
        product: this.$route.params.product
      }
    })
  },
  methods:{
    // mouseover(){
    //   this.isHover = true
    // },
    // mouseleave(){
    //   this.isHover = false
    // },
    toTop() {
      window.scrollTo(0, 0)
    },
  }
}
</script>

<style>
  body {
    background-color: #e6e6e6 !important;
    line-height: 1.42857143;
    margin: 0;
    padding: 0;
  }
#app {
  padding: 0;
  margin: 0;
}
.ck-navtop {
  background-color: #fff;
  border-bottom: 2px #0c368a solid;
  line-height: 58px;
}
  .ck-navtop .div-img {
    float: left;
    margin-right: 50px;
    margin-bottom: 0;
  }
  .wf-nav .nav-logo {
    line-height: 58px;
  }
  .wf-nav .nav-logo .logo1 {
    display: inline-block;
    vertical-align: middle;
  }
  .wf-nav .nav-logo .vr {
    margin-right: 10px;
    margin-left: 10px;
    height: 42px;
    width: 1px;
    background: #e8e8e8;
    display: inline-block;
    vertical-align: middle;
  }
  .wf-nav .nav-logo .sublogo {
    display: inline-block;
    vertical-align: middle;
  }
  .ck-navtop ul.nav {
    font-size: 15px;
    float: left;
  }
  .ck-navtop ul.nav li {
    float: left;
    position: relative;
    font-size: inherit;
  }
  .ck-navtop ul.nav li>a:hover, .ck-navtop ul.nav li.active>a {
    color: #0c368a;
    background-color: transparent;
  }

  .ck-navtop ul.nav li>a {
    padding: 0;
    margin: 0 15px;
    color: #565656;
    position: relative;
  }
  .ck-navtop ul.nav li>a:hover:after, .ck-navtop ul.nav li.active>a:after {
    transition: all .3s;
    height: 2px;
    opacity: 1;
    filter: Alpha(opacity=100);
  }

  .ck-navtop ul.nav li>a:after {
    content: "";
    display: inline-block;
    position: absolute;
    left: 0px;
    bottom: -10px;
    width: 100%;
    height: 0px;
    background-color: #0c368a;
    opacity: 0;
    filter: Alpha(opacity=0);
  }
  .ck-footer {
    background-color: #222222;
    font-size: 12px;
    font-family: SimSun;
    color: #a9a9a9;
    text-align: center;
  }
  .ck-footer .copy-right {
    line-height: 54px;
  }
  .clearfix:before, .clearfix:after {
    content: " ";
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .wf-side-bar {
    background-color: #fff;
    position: fixed;
    right: 0;
    bottom: 20%;
    z-index: 100;
    border-radius: 4px;
  }
  .wf-side-bar ul {
    box-sizing: border-box;
    box-shadow: 0 0 20px 1px rgba(0,0,0,.1);
  }
  .wf-side-bar ul li.side-kf {
    cursor: pointer;
    font-size: 12px;
  }
  .wf-side-bar ul li.side-qq {
    /* cursor: pointer; */
    font-size: 12px;
  }
  .wf-side-bar ul li:first-child {
    border: none;
  }
  .wf-side-bar ul li {
    padding: 12px 10px;
    height: 75px;
    position: relative;
    text-align: center;
  }
  .wf-side-bar ul li.side-kf a {
    color: #666;
  }
  .wf-side-bar ul li.side-kf .img-box {
    background: url(./assets/images/side-kf.png) no-repeat;
    background-size: cover;
    height: 32px;
  }
  .wf-side-bar ul li.side-wx .img-box {
    background: url(./assets/images/img-side-wx.png) no-repeat;
    background-size: cover;
  }
  .wf-side-bar ul li.side-qq .img-box {
    background: url(./assets/images/img-side-qq.png) no-repeat;
    background-size: cover;
    height: 30px;
  }
  .wf-side-bar ul li.side-gt{
    cursor: pointer;
  }
  .wf-side-bar ul li.side-gt .img-box {
    background: url(./assets/images/img-side-gotop.png) no-repeat;
    background-size: cover;
  }
  .wf-side-bar ul li .img-box {
    width: 30px;
    height: 24px;
    margin: auto;
  }
  .wf-side-bar ul li.side-kf p {
    padding: 5px 0;
  }

  .wf-side-bar ul li .side-layout {
    display: none;
    border-radius: 4px;
    padding: 25px 20px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 0 20px 1px rgba(0,0,0,.1);
    position: absolute;
    right: 75px;
    top: 0;
  }
  .wf-side-bar ul li:hover .side-layout {
    display: block;
  }
  .wf-side-bar ul li .side-layout .blue-head {
    width: 100%;
    height: 5px;
    background: linear-gradient(to right,#073b7b,#2773c9);
    position: absolute;
    top: 0;
    left: 0;
  }
  .wf-side-bar ul li.side-wx .side-box {
    width: 160px;
    text-align: center;
  }
  .wf-side-bar ul li.side-wx .side-box p {
    font-size: 12px;
  }
  .wf-side-bar ul li.side-qq .side-box {
    width: 160px;
    /* text-align: center; */
    color:#fff;
    background-color: #0d4f95;
  }
  .wf-side-bar ul li.side-qq .side-layout{
    padding:0;
  }

  .wf-side-bar ul li:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    margin: 4px auto;
    background-color: #ddd;
}
</style>
